import Settings from 'portal-base/src/utils/Settings';

import { SharedChannelStore } from 'ds-shared-lib/src/stores/SharedChannelStore';
import { SystemParametersStore } from 'ds-shared-lib/src/stores/SystemParametersStore';

import { initToastService } from '../services/toast-service';
import { AlarmingStore } from '../store/AlarmingStore';
import { detectLocale } from '../utils/locale';
import { getRuntimeConfig } from './runtime-config';

export function bootstrap() {
    const { portalBaseUrl } = getRuntimeConfig();

    const settings = new Settings();
    settings.locale = detectLocale(window.navigator.language);
    settings.languageFallback = true;

    AlarmingStore.setTarget(portalBaseUrl);
    SharedChannelStore.setTarget(portalBaseUrl);
    SystemParametersStore.setTarget(portalBaseUrl);

    window.openPopupRegistry = [];

    initToastService();
    generateManifest();
}

function generateManifest() {
    const baseURL = new URL('./', location.href).href;
    const startURL = `${baseURL}${location.pathname.split('/').pop()}${location.search}`;

    const manifest = {
        theme_color: '#FFFFFF',
        background_color: '#FFFFFF',
        display: 'standalone',
        start_url: startURL,
        scope: baseURL,
        name: 'datasphere',
        short_name: 'datasphere',
        description: 'Keep track of your data with datasphere!',
        gcm_user_visible_only: true,
        icons: [
            {
                src: `${baseURL}assets/favicon.svg`,
                sizes: 'any',
                type: 'image/svg+xml',
                purpose: 'any',
            },
        ],
        screenshots: [
            {
                src: `${baseURL}assets/datasphereLogo.svg`,
                sizes: 'any',
                type: 'image/svg+xml',
                form_factor: 'wide',
            },
            {
                src: `${baseURL}assets/datasphereLogo.svg`,
                sizes: 'any',
                type: 'image/svg+xml',
                form_factor: 'narrow',
            },
        ],
    };

    const blob = new Blob([JSON.stringify(manifest)], { type: 'application/json' });
    const manifestURL = URL.createObjectURL(blob);
    document.querySelector('link[rel="manifest"]').setAttribute('href', manifestURL);
}
